import { render } from "./UpdateInfo.vue?vue&type=template&id=db69e83a&scoped=true"
import script from "./UpdateInfo.vue?vue&type=script&lang=js"
export * from "./UpdateInfo.vue?vue&type=script&lang=js"

import "./UpdateInfo.vue?vue&type=style&index=0&id=db69e83a&scoped=true&lang=less"

import exportComponent from "/data/jenkins/workspace/vas-web-client-pre/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db69e83a"]])